import React from 'react';
import PolicyPageLayout from '../components/PolicyPageLayout';

const Ethics = () => {
  const sections = [
    {
      title: 'Ethical Standards',
      content: 'The Federal University Wukari Journal of Agriculture and Life Sciences (FUWJALS) is committed to maintaining the highest standards of publication ethics. We adhere to the guidelines established by the Committee on Publication Ethics (COPE) and expect all authors, reviewers, and editors to uphold these ethical principles.'
    },
    {
      title: 'Author Responsibilities',
      content: (
        <>
          <h4>Originality and Plagiarism</h4>
          <ul className="section-list">
            <li>All submitted manuscripts must be original works</li>
            <li>Manuscripts must not be under consideration by other journals</li>
            <li>Plagiarism in any form is strictly prohibited</li>
            <li>Proper citation is required for all referenced materials</li>
            <li>Self-plagiarism (duplicate publication) is not acceptable</li>
          </ul>

          <h4>Authorship</h4>
          <ul className="section-list">
            <li>All listed authors must have made significant contributions to the work</li>
            <li>All contributors who meet authorship criteria should be listed as authors</li>
            <li>Authors must approve the final version before submission</li>
            <li>Changes in authorship must be agreed upon by all authors</li>
            <li>Ghost authorship and gift authorship are prohibited</li>
          </ul>

          <h4>Data and Research Integrity</h4>
          <ul className="section-list">
            <li>Research data must be accurate and honestly reported</li>
            <li>Data fabrication and falsification are serious misconduct</li>
            <li>Raw data should be available for verification when requested</li>
            <li>Statistical analyses must be appropriate and correctly applied</li>
            <li>Images and figures must not be manipulated inappropriately</li>
          </ul>
        </>
      )
    },
    {
      title: 'Research Ethics',
      content: (
        <>
          <h4>Human Subjects Research</h4>
          <ul className="section-list">
            <li>Research involving human subjects must have ethical approval</li>
            <li>Informed consent must be obtained from all participants</li>
            <li>Privacy and confidentiality must be protected</li>
            <li>Vulnerable populations require special protection</li>
            <li>Risk-benefit analysis must be favorable</li>
          </ul>

          <h4>Animal Research</h4>
          <ul className="section-list">
            <li>Animal research must comply with institutional guidelines</li>
            <li>Appropriate animal care and use committee approval is required</li>
            <li>The 3Rs principle (Replace, Reduce, Refine) should be followed</li>
            <li>Animal welfare must be prioritized</li>
            <li>Unnecessary pain and distress must be avoided</li>
          </ul>
        </>
      )
    },
    {
      title: 'Conflicts of Interest',
      content: 'All authors must disclose any financial, professional, or personal relationships that could potentially bias their work. This includes:',
      list: [
        'Financial support from organizations that may gain or lose from publication',
        'Employment or consulting relationships',
        'Stock ownership or other financial interests',
        'Personal relationships with individuals involved in the research',
        'Academic competition or collaboration'
      ]
    },
    {
      title: 'Reviewer Ethics',
      list: [
        'Reviewers must maintain confidentiality of manuscripts',
        'Objective and constructive feedback should be provided',
        'Personal or professional conflicts must be declared',
        'Reviews should be completed in a timely manner',
        'Suspected misconduct should be reported to editors',
        'Reviewers should not use manuscript information for personal advantage'
      ]
    },
    {
      title: 'Editorial Responsibilities',
      list: [
        'Fair and unbiased evaluation of all manuscripts',
        'Protection of confidential information',
        'Timely handling of submissions',
        'Appropriate selection of qualified reviewers',
        'Investigation of allegations of misconduct',
        'Maintaining the integrity of the publication process'
      ]
    },
    {
      title: 'Misconduct Allegations',
      content: 'If you suspect research or publication misconduct, please contact the editorial office. All allegations will be investigated according to COPE guidelines. Types of misconduct include:',
      list: [
        'Plagiarism and duplicate publication',
        'Data fabrication or falsification',
        'Inappropriate authorship',
        'Failure to disclose conflicts of interest',
        'Violation of research ethics'
      ],
      highlight: (
        <>Contact: <a href="mailto:ethics@fuwukari.edu.ng">ethics@fuwukari.edu.ng</a></>
      )
    },
    {
      title: 'Corrections and Retractions',
      content: (
        <>
          <p>FUWJALS is committed to correcting the literature when necessary:</p>
          <ul className="section-list">
            <li><strong>Corrections:</strong> For minor errors that do not affect conclusions</li>
            <li><strong>Retractions:</strong> For serious errors, misconduct, or ethical violations</li>
            <li><strong>Expressions of Concern:</strong> When investigation is ongoing</li>
          </ul>
          <p>All corrections and retractions are published openly and linked to the original article.</p>
        </>
      )
    }
  ];

  return (
    <PolicyPageLayout
      title="Publication Ethics"
      sections={sections}
      icon="⚖️"
    />
  );
};

export default Ethics;